import { memo, useState } from "react";
import { AddImages } from "../../../../components/AddImages/AddImages";
import Demo from "./Demo/Demo";
import Name from "./Name/Name";
import Highlight from "./Highlight/Highlight";
import { FixaListView } from "@coworker/apprestructured/src/shared/wrappers/FixaListView/FixaListView";
import Actions from "@coworker/apprestructured/src/task-management/demo/pages/ComponentDemoPage/demos/Actions/Actions";
import FixaCheckbox from "@coworker/apprestructured/src/shared/wrappers/FixaCheckbox/FixaCheckbox";

function AddImagesDemo() {
  const [images, setImages] = useState<File[]>([]);
  const [disabled, setDisabled] = useState(false);

  return (
    <Demo>
      <Name>AddImages</Name>
      <Highlight>
        <FixaListView id="addimagesdemo" size="small">
          <AddImages
            images={images}
            onConfirmClick={setImages}
            disabled={disabled}
          />
        </FixaListView>
      </Highlight>
      <Actions>
        <FixaCheckbox
          label="disabled"
          value="addimagesdemo-disabled"
          id="addimagesdemo-disabled"
          checked={disabled}
          onChange={() => setDisabled((prev) => !prev)}
        />
      </Actions>
    </Demo>
  );
}

export default memo(AddImagesDemo);
